module.exports = __webpack_public_path__ + "images/177_2048.jpg";